import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { AmountValidationDialogComponent } from '@pages/payment/dialog/amountvalidation/amountvalidation.component';

@NgModule({
  declarations: [
    AmountValidationDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatInputModule
  ],
  exports: [
    AmountValidationDialogComponent
  ],
})

export class AmountValidationDialogModule {
}
